import { render, staticRenderFns } from "./DetailsAttivita.vue?vue&type=template&id=22a06dc3&scoped=true&"
import script from "./DetailsAttivita.vue?vue&type=script&lang=ts&"
export * from "./DetailsAttivita.vue?vue&type=script&lang=ts&"
import style0 from "./DetailsAttivita.vue?vue&type=style&index=0&id=22a06dc3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a06dc3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
